// extracted by mini-css-extract-plugin
export var icon = "Icon-module--icon--c95f8";